The date the certification was issued.

This will be `null` if the issue date is unknown or not provided.
